// import { Container, Card, Row, Col } from "react-bootstrap";

// import './AmongTopSolar.css';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay } from 'swiper/modules';
// import 'swiper/css';


// const AmongTopSolar = ({ topSolar = [], heading = "", subHeading = "" }) => {

//     const userSwiper = topSolar.length >= 3;


//     return (
//         <section className="py-5 border-top text-center overflow-hidden px-2" style={{ background: '#E5E7EB' }}>
//             <Container >
//                 <div className="position-relative mb-5 ">
//                     <h2 className=" textRes" style={{ color: "#000",textTransform:'uppercase' }}>
//                         {heading} <span style={{ color: '#a20000' }}>{subHeading}</span>
//                     </h2>
//                 </div>


//                 {userSwiper ? <Swiper
//                     slidesPerView={1}
//                     spaceBetween={20}
//                     autoplay={{
//                         delay: 3000,
//                         disableOnInteraction: false,
//                     }}
//                     breakpoints={{
//                         1200: { slidesPerView: 3 },
//                         992: { slidesPerView: 2 },
//                         710: { slidesPerView: 2 },
//                         576: { slidesPerView: 1 },
//                     }}
//                     loop={true}
//                     modules={[Autoplay]}
//                     className="mySwiper overflow-hidden"
//                 >
//                     {topSolar?.map((item, index) => (

//                         <SwiperSlide key={`media-${index}`}>
//                             <Card className="h-100 border-none">
//                                 <Card.Body className="d-flex flex-column justify-content-between align-items-center border rounded">
//                                     <img
//                                         className="img-fluid rounded shadow-sm"
//                                         style={{ width: '100%'}}
//                                         src={item.img}
//                                         alt={item.title}
//                                         width={600}
//                                         height={600}
//                                         loading="lazy"
//                                     />
//                                     <Card.Body className="d-flex flex-column justify-content-between">
//                                         <Card.Title className="fw-semibold text-dark text-center mt-auto mb-0">
//                                             {item.title}
//                                         </Card.Title>
//                                         <p style={{ fontWeight: '500', fontSize: '13px' }}>{item.desc}</p>
//                                     </Card.Body>
//                                 </Card.Body>

//                             </Card>
//                         </SwiperSlide>


//                     ))}
//                 </Swiper> :

//                     <Row className="g-4 justify-content-center">
//                         {topSolar.map((item, index) => (
//                             <Col key={index} lg={5} md={9} sm={12}>
//                                 <Card className="h-100 shadow-sm">
//                                     <Card.Body className="d-flex flex-column p-2">

//                                             <img
//                                              style={{width:"100%"}}
//                                                 src={item.img}
//                                                 alt={item.title}
//                                                 className="w-100 rounded"
//                                                 loading="lazy"
//                                             />
//                                     </Card.Body>
//                                 </Card>
//                             </Col>
//                         ))}
//                     </Row>


//                 }

//             </Container>
//         </section>
//     );
// };

// export default AmongTopSolar;






import { Container, Card, Row, Col } from "react-bootstrap";
import './AmongTopSolar.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const AmongTopSolar = ({ topSolar = [], heading = "", subHeading = "" }) => {
    const userSwiper = topSolar.length >= 3;

    // Shared image style: same height for all images
    const imageStyle = {
        width: "100%",
        height: "500px",          // fixed height – adjust as needed
        objectFit: "contain",     // shows full image without cropping
        backgroundColor: "#f8f9fa"
    };

    return (
        <section className="py-5 border-top text-center overflow-hidden px-2" style={{ background: '#E5E7EB' }}>
            <Container>
                <div className="position-relative mb-5">
                    <h2 className="textRes" style={{ color: "#000", textTransform: 'uppercase' }}>
                        {heading} <span style={{ color: '#a20000' }}>{subHeading}</span>
                    </h2>
                </div>

                {userSwiper ? (
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={20}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        breakpoints={{
                            1200: { slidesPerView: 3 },
                            992: { slidesPerView: 2 },
                            710: { slidesPerView: 2 },
                            576: { slidesPerView: 1 },
                        }}
                        loop={true}
                        modules={[Autoplay]}
                        className="mySwiper overflow-hidden"
                    >
                        {topSolar?.map((item, index) => (
                            <SwiperSlide key={`media-${index}`}>
                                <Card className="h-100 border-none">
                                    {/* Removed duplicate Card.Body */}
                                    <Card.Body className="d-flex flex-column justify-content-between align-items-center border rounded">
                                        <img
                                            className="rounded shadow-sm"
                                            style={imageStyle}
                                            src={item.img}
                                            alt={item.title}
                                            loading="lazy"
                                        />
                                        <Card.Body className="d-flex flex-column justify-content-between">
                                            <Card.Title className="fw-semibold text-dark text-center mt-auto mb-0">
                                                {item.title}
                                            </Card.Title>
                                            <p style={{ fontWeight: '500', fontSize: '13px' }}>{item.desc}</p>
                                        </Card.Body>
                                    </Card.Body>
                                </Card>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <Row className="g-4 justify-content-center">
                        {topSolar.map((item, index) => (
                            <Col key={index} lg={5} md={9} sm={12}>
                                <Card className="h-100 shadow-sm">
                                    <Card.Body className="d-flex flex-column p-2">
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                            className="rounded"
                                            style={imageStyle}   // same fixed height
                                            loading="lazy"
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
            </Container>
        </section>
    );
};

export default AmongTopSolar;